import styled from "styled-components";
import { Markdown } from "./Markdown";

const orange = "#c2571d";

const Container = styled.div<{ fontSize?: number }>`
  display: inherit !important;
  flex-direction: column;
  white-space: normal !important;
  overflow: hidden;
  font-size: calc((25 + 5 * ${({ fontSize = 3 }) => fontSize}) * var(--h));
  font-family: "BarlowCondensed", sans-serif;
  color: black;

  a {
    color: inherit;
  }

  p {
    width: 100%;
    margin: 0px;
  }

  img {
    display: inline;
    max-height: 100%;
    width: auto;
    padding: calc(1 * var(--h));
  }

  ul {
    margin: 0;
    padding-left: calc(20 * var(--w));
    display: inline-block;
    text-align: inherit;

    li {
      display: list-item;
      padding: calc(3 * var(--h)) 0;
      padding-left: 0;
      margin: 0;
      list-style: none;
    }

    li:before {
      content: "•";
      color: ${orange};
      font-weight: bold;
      display: inline-block;
      width: calc(40 * var(--h));
    }

    img {
      max-height: calc(100 * var(--h));
    }
  }
`;

export function CardSlot({ md, fontSize }: { md: string; fontSize?: number }) {
  return (
    <Container fontSize={fontSize}>
      <Markdown md={md} />
    </Container>
  );
}
